export const phraseTranslations = {
  'seeds of beans': { 
    en: 'seeds of beans', 
    ru: 'семена фасоли', 
    ge: 'ლობიო',
    it: 'semi di fagioli', 
    tr: 'fasulye tohumları', 
    ar: 'بذور الفاصوليا' 
  },
  'seeds of beans, onions': { 
    en: 'seeds of beans, onions', 
    ru: 'фасоль, лук', 
    ge: 'ლობიო, ხახვი', 
    it: 'fagioli, cipolle', 
    tr: 'fasulye, soğan', 
    ar: 'فاصوليا، بصل' 
  },
  'georgian spices': {
    en: 'georgian spices',
    ru: 'грузинские специи', 
    ge: 'ქართული სანელებლები',
    it: 'spezie georgiane',
    tr: 'gürcü baharatları',
    ar: 'بهارات جورجية'
  },
  'mixed pickle assortment': {
    en: 'mixed pickle assortment',
    ru: 'ассорти солений',
    ge: 'მარინადების ასორტი',
    it: 'assortimento di sottaceti',
    tr: 'turşu çeşitleri',
    ar: 'تشكيلة مخللات'
  },
  'mountain peppers': {
    en: 'mountain peppers',
    ru: 'горный перец',
    ge: 'მთის წიწაკა',
    it: 'peperoni di montagna',
    tr: 'dağ biberi',
    ar: 'فلفل جبلي'
  },
  'herbal tea': {
    en: 'herbal tea',
    ru: 'травяной чай',
    ge: 'მწვანილის ჩაი',
    it: 'tisana',
    tr: 'bitki çayı',
    ar: 'شاي أعشاب'
  },
  'fried eggs': {
    en: 'fried eggs',
    ru: 'жареные яйца',
    ge: 'შემწვარი კვერცხი',
    it: 'uova fritte',
    tr: 'sahanda yumurta',
    ar: 'بيض مقلي'
  },
  'two fried eggs': {
    en: 'two fried eggs',
    ru: 'два жареных яйца',
    ge: 'ორი შემწვარი კვერცხი',
    it: 'due uova fritte',
    tr: 'iki sahanda yumurta',
    ar: 'بيضتان مقليتان'
  },
  'chicken breast': {
    en: 'chicken breast',
    ru: 'куриная грудка',
    ge: 'ქათმის მკერდი',
    it: 'petto di pollo',
    tr: 'tavuk göğsü',
    ar: 'صدر دجاج'
  },
  'beef fillet': {
    en: 'beef fillet',
    ru: 'говяжье филе',
    ge: 'საქონლის ფილე',
    it: 'filetto di manzo',
    tr: 'dana fileto',
    ar: 'فيليه لحم بقر'
  },
  'pork shoulders': {
    en: 'pork shoulders',
    ru: 'свиная лопатка',
    ge: 'ღორის ბეჭი',
    it: 'spalla di maiale',
    tr: 'domuz omuz',
    ar: 'كتف خنزير'
  },
  'cheese sauce': {
    en: 'cheese sauce',
    ru: 'сырный соус',
    ge: 'ყველის სოუსი',
    it: 'salsa al formaggio',
    tr: 'peynir sosu',
    ar: 'صلصة الجبن'
  },
  'sour cream': {
    en: 'sour cream',
    ru: 'сметана',
    ge: 'არაჟანი',
    it: 'panna acida',
    tr: 'ekşi krema',
    ar: 'كريمة حامضة'
  },
  'avocado cream': {
    en: 'avocado cream',
    ru: 'крем из авокадо',
    ge: 'ავოკადოს კრემი',
    it: 'crema di avocado',
    tr: 'avokado kreması',
    ar: 'كريمة الأفوكادو'
  },
  'fresh cilantro': {
    en: 'fresh cilantro',
    ru: 'свежая кинза',
    ge: 'ახალი ქინძი',
    it: 'coriandolo fresco',
    tr: 'taze kişniş',
    ar: 'كزبرة طازجة'
  },
  'dried spices': {
    en: 'dried spices',
    ru: 'сушеные специи',
    ge: 'გამხმარი სანელებლები',
    it: 'spezie secche',
    tr: 'kuru baharatlar',
    ar: 'بهارات مجففة'
  },
  'mexican rice': {
    en: 'mexican rice',
    ru: 'мексиканский рис',
    ge: 'მექსიკური ბრინჯი',
    it: 'riso messicano',
    tr: 'meksika pilavı',
    ar: 'أرز مكسيكي'
  },
  'mushroom mix': {
    en: 'mushroom mix',
    ru: 'грибной микс',
    ge: 'სოკოს ნაზავი',
    it: 'mix di funghi',
    tr: 'mantar karışımı',
    ar: 'خليط الفطر'
  },
  'cherry tomatoes': {
    en: 'cherry tomatoes',
    ru: 'помидоры черри',
    ge: 'ჩერი პომიდორები',
    it: 'pomodorini',
    tr: 'çeri domates',
    ar: 'طماطم كرزية'
  },
  'toast bread': {
    en: 'toast bread',
    ru: 'тосты',
    ge: 'ტოსტის პური',
    it: 'pane tostato',
    tr: 'tost ekmeği',
    ar: 'خبز محمص'
  },
  'baked beans': {
    en: 'baked beans',
    ru: 'запеченная фасоль',
    ge: 'გამომცხვარი ლობიო',
    it: 'fagioli al forno',
    tr: 'fırında fasulye',
    ar: 'فاصوليا مخبوزة'
  },
  'tomato sauce': {
    en: 'tomato sauce',
    ru: 'томатный соус',
    ge: 'ტომატის სოუსი',
    it: 'salsa di pomodoro',
    tr: 'domates sosu',
    ar: 'صلصة طماطم'
  },
  'in a tomato sauce': {
    en: 'in a tomato sauce',
    ru: 'в томатном соусе',
    ge: 'ტომატის სოუსში',
    it: 'in salsa di pomodoro',
    tr: 'domates sosunda',
    ar: 'في صلصة الطماطم'
  },
  'edamame beans': {
    en: 'edamame beans',
    ru: 'эдамаме',
    ge: 'ედამამეს მარცვლები',
    it: 'edamame',
    tr: 'edamame',
    ar: 'فول إدامامي'
  },
  
  // Full descriptions that need special handling
  'seeds of beans, onions, georgian spices, garlic, celery, coriander, parsley, mountain peppers, 1 mchadi, mixed pickle assortment': {
    en: 'seeds of beans, onions, georgian spices, garlic, celery, coriander, parsley, mountain peppers, 1 mchadi, mixed pickle assortment',
    ru: 'фасоль, лук, грузинские специи, чеснок, сельдерей, кориандр, петрушка, горный перец, 1 мчади, ассорти солений',
    ge: 'ლობიო, ხახვი, ქართული სანელებლები, ნიორი, ნიახური, ქინძი, ოხრახუში, მთის წიწაკა, 1 მჭადი, მარინადების ასორტი',
    it: 'fagioli, cipolle, spezie georgiane, aglio, sedano, coriandolo, prezzemolo, peperoni di montagna, 1 mchadi, assortimento di sottaceti',
    tr: 'fasulye, soğan, gürcü baharatları, sarımsak, kereviz, kişniş, maydanoz, dağ biberi, 1 mçadi, turşu çeşitleri',
    ar: 'فاصوليا، بصل، بهارات جورجية، ثوم، كرفس، كزبرة، بقدونس، فلفل جبلي، 1 مشادي، تشكيلة مخللات'
  },
  
  'beans, onions, georgian spices, herbal tea': {
    en: 'beans, onions, georgian spices, herbal tea',
    ru: 'фасоль, лук, грузинские специи, травяной чай',
    ge: 'ლობიო, ხახვი, ქართული სანელებლები, მწვანილის ჩაი',
    it: 'fagioli, cipolle, spezie georgiane, tisana',
    tr: 'fasulye, soğan, gürcü baharatları, bitki çayı',
    ar: 'فاصوليا، بصل، بهارات جورجية، شاي أعشاب'
  },
  
  'dough, beans, butter, onion, dried spices': {
    en: 'dough, beans, butter, onion, dried spices',
    ru: 'тесто, фасоль, масло, лук, сушеные специи',
    ge: 'ცომი, ლობიო, კარაქი, ხახვი, გამხმარი სანელებლები',
    it: 'impasto, fagioli, burro, cipolla, spezie secche',
    tr: 'hamur, fasulye, tereyağı, soğan, kuru baharatlar',
    ar: 'عجين، فاصوليا، زبدة، بصل، بهارات مجففة'
  }
};

export const wordTranslations = {
  'beans': { en: 'beans', ru: 'фасоль', ge: 'ლობიო', it: 'fagioli', tr: 'fasulye', ar: 'فاصوليا' },
  'bean': { en: 'bean', ru: 'фасоль', ge: 'ლობიო', it: 'fagiolo', tr: 'fasulye', ar: 'فاصوليا' },
  'onions': { en: 'onions', ru: 'лук', ge: 'ხახვი', it: 'cipolle', tr: 'soğan', ar: 'بصل' },
  'onion': { en: 'onion', ru: 'лук', ge: 'ხახვი', it: 'cipolla', tr: 'soğan', ar: 'بصل' },
  'garlic': { en: 'garlic', ru: 'чеснок', ge: 'ნიორი', it: 'aglio', tr: 'sarımsak', ar: 'ثوم' },
  'tomato': { en: 'tomato', ru: 'помидор', ge: 'პომიდორი', it: 'pomodoro', tr: 'domates', ar: 'طماطم' },
  'tomatoes': { en: 'tomatoes', ru: 'помидоры', ge: 'პომიდორები', it: 'pomodori', tr: 'domatesler', ar: 'طماطم' },
  'pepper': { en: 'pepper', ru: 'перец', ge: 'წიწაკა', it: 'pepe', tr: 'biber', ar: 'فلفل' },
  'peppers': { en: 'peppers', ru: 'перцы', ge: 'წიწაკები', it: 'peperoni', tr: 'biberler', ar: 'فلفل' },
  'salt': { en: 'salt', ru: 'соль', ge: 'მარილი', it: 'sale', tr: 'tuz', ar: 'ملح' },
  'oil': { en: 'oil', ru: 'масло', ge: 'ზეთი', it: 'olio', tr: 'yağ', ar: 'زيت' },
  'butter': { en: 'butter', ru: 'масло', ge: 'კარაქი', it: 'burro', tr: 'tereyağı', ar: 'زبدة' },
  'cheese': { en: 'cheese', ru: 'сыр', ge: 'ყველი', it: 'formaggio', tr: 'peynir', ar: 'جبن' },
  'egg': { en: 'egg', ru: 'яйцо', ge: 'კვერცხი', it: 'uovo', tr: 'yumurta', ar: 'بيضة' },
  'eggs': { en: 'eggs', ru: 'яйца', ge: 'კვერცხი', it: 'uova', tr: 'yumurta', ar: 'بيض' },
  'chicken': { en: 'chicken', ru: 'курица', ge: 'ქათამი', it: 'pollo', tr: 'tavuk', ar: 'دجاج' },
  'beef': { en: 'beef', ru: 'говядина', ge: 'საქონლის ხორცი', it: 'manzo', tr: 'sığır eti', ar: 'لحم بقر' },
  'pork': { en: 'pork', ru: 'свинина', ge: 'ღორის ხორცი', it: 'maiale', tr: 'domuz eti', ar: 'لحم خنزير' },
  'fish': { en: 'fish', ru: 'рыба', ge: 'თევზი', it: 'pesce', tr: 'balık', ar: 'سمك' },
  'rice': { en: 'rice', ru: 'рис', ge: 'ბრინჯი', it: 'riso', tr: 'pirinç', ar: 'أرز' },
  'bread': { en: 'bread', ru: 'хлеб', ge: 'პური', it: 'pane', tr: 'ekmek', ar: 'خبز' },
  'dough': { en: 'dough', ru: 'тесто', ge: 'ცომი', it: 'impasto', tr: 'hamur', ar: 'عجين' },
  'pasta': { en: 'pasta', ru: 'паста', ge: 'პასტა', it: 'pasta', tr: 'makarna', ar: 'معكرونة' },
  'potato': { en: 'potato', ru: 'картофель', ge: 'კარტოფილი', it: 'patata', tr: 'patates', ar: 'بطاطس' },
  'mushroom': { en: 'mushroom', ru: 'гриб', ge: 'სოკო', it: 'fungo', tr: 'mantar', ar: 'فطر' },
  'mushrooms': { en: 'mushrooms', ru: 'грибы', ge: 'სოკო', it: 'funghi', tr: 'mantar', ar: 'فطر' },
  'lettuce': { en: 'lettuce', ru: 'салат', ge: 'სალათი', it: 'lattuga', tr: 'marul', ar: 'خس' },
  'cucumber': { en: 'cucumber', ru: 'огурец', ge: 'კიტრი', it: 'cetriolo', tr: 'salatalık', ar: 'خيار' },
  'carrot': { en: 'carrot', ru: 'морковь', ge: 'სტაფილო', it: 'carota', tr: 'havuç', ar: 'جزر' },
  'corn': { en: 'corn', ru: 'кукуруза', ge: 'სიმინდი', it: 'mais', tr: 'mısır', ar: 'ذرة' },
  'spinach': { en: 'spinach', ru: 'шпинат', ge: 'ისპანახი', it: 'spinaci', tr: 'ıspanak', ar: 'سبانخ' },
  'parsley': { en: 'parsley', ru: 'петрушка', ge: 'ოხრახუში', it: 'prezzemolo', tr: 'maydanoz', ar: 'بقدونس' },
  'red pepper': { en: 'red pepper', ru: 'красный перец', ge: 'წითელი წიწაკა', it: 'pepe rosso', tr: 'kırmızı biber', ar: 'فلفل أحمر' },
  'cilantro': { en: 'cilantro', ru: 'кинза', ge: 'ქინძი', it: 'coriandolo', tr: 'kişniş', ar: 'كزبرة' },
  'coriander': { en: 'coriander', ru: 'кориандр', ge: 'ქინძი', it: 'coriandolo', tr: 'kişniş', ar: 'كزبرة' },
  'dill': { en: 'dill', ru: 'укроп', ge: 'კამა', it: 'aneto', tr: 'dereotu', ar: 'شبت' },
  'basil': { en: 'basil', ru: 'базилик', ge: 'რეჰანი', it: 'basilico', tr: 'fesleğen', ar: 'ريحان' },
  'celery': { en: 'celery', ru: 'сельдерей', ge: 'ნიახური', it: 'sedano', tr: 'kereviz', ar: 'كرفس' },
  'ginger': { en: 'ginger', ru: 'имбирь', ge: 'ჯანჯაფილი', it: 'zenzero', tr: 'zencefil', ar: 'زنجبيل' },
  'lemon': { en: 'lemon', ru: 'лимон', ge: 'ლიმონი', it: 'limone', tr: 'limon', ar: 'ليمون' },
  'lime': { en: 'lime', ru: 'лайм', ge: 'ლაიმი', it: 'lime', tr: 'misket limonu', ar: 'ليمون أخضر' },
  'avocado': { en: 'avocado', ru: 'авокадо', ge: 'ავოკადო', it: 'avocado', tr: 'avokado', ar: 'أفوكادو' },
  'olives': { en: 'olives', ru: 'оливки', ge: 'ზეთისხილი', it: 'olive', tr: 'zeytin', ar: 'زيتون' },
  
  // Meats
  'bacon': { en: 'bacon', ru: 'бекон', ge: 'ბეკონი', it: 'pancetta', tr: 'domuz pastırması', ar: 'لحم مقدد' },
  'sausage': { en: 'sausage', ru: 'колбаса', ge: 'ძეხვი', it: 'salsiccia', tr: 'sosis', ar: 'نقانق' },
  'ham': { en: 'ham', ru: 'ветчина', ge: 'ლორი', it: 'prosciutto', tr: 'jambon', ar: 'لحم خنزير مدخن' },
  
  // Dairy
  'milk': { en: 'milk', ru: 'молоко', ge: 'რძე', it: 'latte', tr: 'süt', ar: 'حليب' },
  'cream': { en: 'cream', ru: 'сливки', ge: 'ნაღები', it: 'panna', tr: 'krema', ar: 'كريمة' },
  'yogurt': { en: 'yogurt', ru: 'йогурт', ge: 'იოგურტი', it: 'yogurt', tr: 'yoğurt', ar: 'زبادي' },
  'mozzarella': { en: 'mozzarella', ru: 'моцарелла', ge: 'მოცარელა', it: 'mozzarella', tr: 'mozzarella', ar: 'موتزاريلا' },
  
  // Bread types
  'tortilla': { en: 'tortilla', ru: 'тортилья', ge: 'ტორტილია', it: 'tortilla', tr: 'tortilla', ar: 'تورتيلا' },
  'pita': { en: 'pita', ru: 'пита', ge: 'პიტა', it: 'pita', tr: 'pide', ar: 'خبز بيتا' },
  'lavash': { en: 'lavash', ru: 'лаваш', ge: 'ლავაში', it: 'lavash', tr: 'lavaş', ar: 'لافاش' },
  
  // Sauces
  'ketchup': { en: 'ketchup', ru: 'кетчуп', ge: 'კეტჩუპი', it: 'ketchup', tr: 'ketçap', ar: 'كاتشب' },
  'mayonnaise': { en: 'mayonnaise', ru: 'майонез', ge: 'მაიონეზი', it: 'maionese', tr: 'mayonez', ar: 'مايونيز' },
  'mayo': { en: 'mayo', ru: 'майонез', ge: 'მაიონეზი', it: 'maionese', tr: 'mayonez', ar: 'مايونيز' },
  'mustard': { en: 'mustard', ru: 'горчица', ge: 'მდოგვი', it: 'senape', tr: 'hardal', ar: 'خردل' },
  'sauce': { en: 'sauce', ru: 'соус', ge: 'სოუსი', it: 'salsa', tr: 'sos', ar: 'صلصة' },
  'hummus': { en: 'hummus', ru: 'хумус', ge: 'ჰუმუსი', it: 'hummus', tr: 'humus', ar: 'حمص' },
  'tahini': { en: 'tahini', ru: 'тахини', ge: 'ტაჰინი', it: 'tahina', tr: 'tahin', ar: 'طحينة' },
  'sriracha': { en: 'sriracha', ru: 'шрирача', ge: 'სრირაჩა', it: 'sriracha', tr: 'sriracha', ar: 'سريراتشا' },
  
  // Descriptive words
  'fresh': { en: 'fresh', ru: 'свежий', ge: 'ახალი', it: 'fresco', tr: 'taze', ar: 'طازج' },
  'fried': { en: 'fried', ru: 'жареный', ge: 'შემწვარი', it: 'fritto', tr: 'kızarmış', ar: 'مقلي' },
  'sunny side up': { en: 'sunny side up', ru: 'яичница-глазунья', ge: 'კვერცხი ცალმხრივი', it: 'uovo all\'occhio di bue', tr: 'tek taraflı sahanda yumurta', ar: 'بيض مقلي من جانب واحد' },
  'grilled': { en: 'grilled', ru: 'гриль', ge: 'გრილზე შემწვარი', it: 'grigliato', tr: 'ızgara', ar: 'مشوي' },
  'baked': { en: 'baked', ru: 'запеченный', ge: 'გამომცხვარი', it: 'al forno', tr: 'fırında', ar: 'مخبوز' },
  'boiled': { en: 'boiled', ru: 'вареный', ge: 'მოხარშული', it: 'bollito', tr: 'haşlanmış', ar: 'مسلوق' },
  'pickled': { en: 'pickled', ru: 'маринованный', ge: 'მარინადი', it: 'sottaceto', tr: 'turşu', ar: 'مخلل' },
  'mixed': { en: 'mixed', ru: 'смешанный', ge: 'შერეული', it: 'misto', tr: 'karışık', ar: 'مختلط' },
  'dried': { en: 'dried', ru: 'сушеный', ge: 'გამხმარი', it: 'secco', tr: 'kurutulmuş', ar: 'مجفف' },
  'spicy': { en: 'spicy', ru: 'острый', ge: 'ცხარე', it: 'piccante', tr: 'baharatlı', ar: 'حار' },
  'sweet': { en: 'sweet', ru: 'сладкий', ge: 'ტკბილი', it: 'dolce', tr: 'tatlı', ar: 'حلو' },
  'sour': { en: 'sour', ru: 'кислый', ge: 'მჟავე', it: 'aspro', tr: 'ekşi', ar: 'حامض' },
  
  // Georgian specific
  'mchadi': { en: 'mchadi', ru: 'мчади', ge: 'მჭადი', it: 'mchadi', tr: 'mçadi', ar: 'مشادي' },
  'khachapuri': { en: 'khachapuri', ru: 'хачапури', ge: 'ხაჭაპური', it: 'khachapuri', tr: 'haçapuri', ar: 'خاتشابوري' },
  'lobiani': { en: 'lobiani', ru: 'лобиани', ge: 'ლობიანი', it: 'lobiani', tr: 'lobiani', ar: 'لوبياني' },
  'tkemali': { en: 'tkemali', ru: 'ткемали', ge: 'ტყემალი', it: 'tkemali', tr: 'tkemali', ar: 'تكيمالي' },
  'ajika': { en: 'ajika', ru: 'аджика', ge: 'აჯიკა', it: 'ajika', tr: 'acika', ar: 'أجيكا' },
  'sulguni': { en: 'sulguni', ru: 'сулугуни', ge: 'სულგუნი', it: 'sulguni', tr: 'sulguni', ar: 'سولغوني' },
  
  // Others
  'spices': { en: 'spices', ru: 'специи', ge: 'სანელებლები', it: 'spezie', tr: 'baharatlar', ar: 'بهارات' },
  'herbs': { en: 'herbs', ru: 'травы', ge: 'მწვანილები', it: 'erbe', tr: 'otlar', ar: 'أعشاب' },
  'tea': { en: 'tea', ru: 'чай', ge: 'ჩაი', it: 'tè', tr: 'çay', ar: 'شاي' },
  'water': { en: 'water', ru: 'вода', ge: 'წყალი', it: 'acqua', tr: 'su', ar: 'ماء' },
  'wine': { en: 'wine', ru: 'вино', ge: 'ღვინო', it: 'vino', tr: 'şarap', ar: 'نبيذ' },
  'beer': { en: 'beer', ru: 'пиво', ge: 'ლუდი', it: 'birra', tr: 'bira', ar: 'بيرة' },
  'coffee': { en: 'coffee', ru: 'кофе', ge: 'ყავა', it: 'caffè', tr: 'kahve', ar: 'قهوة' },
  'dessert': { en: 'dessert', ru: 'десерт', ge: 'დესერტი', it: 'dolce', tr: 'tatlı', ar: 'حلوى' },
  'salad': { en: 'salad', ru: 'салат', ge: 'სალათი', it: 'insalata', tr: 'salata', ar: 'سلطة' },
  'soup': { en: 'soup', ru: 'суп', ge: 'სუპი', it: 'zuppa', tr: 'çorba', ar: 'حساء' },
  'burger': { en: 'burger', ru: 'бургер', ge: 'ბურგერი', it: 'hamburger', tr: 'burger', ar: 'برغر' },
  'pizza': { en: 'pizza', ru: 'пицца', ge: 'პიცა', it: 'pizza', tr: 'pizza', ar: 'بيتزا' },
  'sandwich': { en: 'sandwich', ru: 'сэндвич', ge: 'სენდვიჩი', it: 'panino', tr: 'sandviç', ar: 'ساندويتش' },
  'wrap': { en: 'wrap', ru: 'ролл', ge: 'როლი', it: 'wrap', tr: 'dürüm', ar: 'راب' },
  'shawarma': { en: 'shawarma', ru: 'шаурма', ge: 'შაურმა', it: 'shawarma', tr: 'şavarma', ar: 'شاورما' },
  'burrito': { en: 'burrito', ru: 'буррито', ge: 'ბურიტო', it: 'burrito', tr: 'burrito', ar: 'بوريتو' },
  'quesadilla': { en: 'quesadilla', ru: 'кесадилья', ge: 'კესადილია', it: 'quesadilla', tr: 'quesadilla', ar: 'كيساديلا' },
  'fajita': { en: 'fajita', ru: 'фахита', ge: 'ფახიტა', it: 'fajita', tr: 'fajita', ar: 'فاهيتا' },
  'taco': { en: 'taco', ru: 'тако', ge: 'ტაკო', it: 'taco', tr: 'taco', ar: 'تاكو' },
  
  // Common prepositions and articles
  'with': { en: 'with', ru: 'с', ge: '-ით', it: 'con', tr: 'ile', ar: 'مع' },
  'without': { en: 'without', ru: 'без', ge: 'გარეშე', it: 'senza', tr: 'olmadan', ar: 'بدون' },
  'and': { en: 'and', ru: 'и', ge: 'და', it: 'e', tr: 've', ar: 'و' },
  'or': { en: 'or', ru: 'или', ge: 'ან', it: 'o', tr: 'veya', ar: 'أو' },
  'in': { en: 'in', ru: 'в', ge: '-ში', it: 'in', tr: 'içinde', ar: 'في' },
  'on': { en: 'on', ru: 'на', ge: '-ზე', it: 'su', tr: 'üzerinde', ar: 'على' },
  'of': { en: 'of', ru: 'из', ge: '-ის', it: 'di', tr: '-nin', ar: 'من' },
  'two': { en: 'two', ru: 'два', ge: 'ორი', it: 'due', tr: 'iki', ar: 'اثنان' },
  'three': { en: 'three', ru: 'три', ge: 'სამი', it: 'tre', tr: 'üç', ar: 'ثلاثة' },
  '1': { en: '1', ru: '1', ge: '1', it: '1', tr: '1', ar: '١' },
  '2': { en: '2', ru: '2', ge: '2', it: '2', tr: '2', ar: '٢' },
  '3': { en: '3', ru: '3', ge: '3', it: '3', tr: '3', ar: '٣' },
};

export function smartTranslateIngredients(text, targetLanguage) {
  if (!text || !targetLanguage || targetLanguage === 'en') return text;
  
  const translatedRanges = [];
  
  const lowerText = text.toLowerCase();
  if (phraseTranslations[lowerText] && phraseTranslations[lowerText][targetLanguage]) {
    return phraseTranslations[lowerText][targetLanguage];
  }
  
  let result = text;
  
  const sortedPhrases = Object.keys(phraseTranslations).sort((a, b) => b.length - a.length);
  
  for (const phrase of sortedPhrases) {
    const translations = phraseTranslations[phrase];
    if (translations && translations[targetLanguage]) {
      const regex = new RegExp(`(?<!\\w)${phrase.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')}(?!\\w)`, 'gi');
      result = result.replace(regex, (match, offset) => {
        if (translatedRanges.some(range => offset >= range.start && offset < range.end)) {
          return match;
        }
        
        translatedRanges.push({ start: offset, end: offset + match.length });
        return translations[targetLanguage];
      });
    }
  }
  
  const sortedWords = Object.keys(wordTranslations).sort((a, b) => b.length - a.length);
  
  for (const word of sortedWords) {
    const translations = wordTranslations[word];
    if (translations && translations[targetLanguage]) {
      const regex = new RegExp(`(?<!\\w)${word}(?!\\w)`, 'gi');
      result = result.replace(regex, (match, offset) => {
        if (translatedRanges.some(range => offset >= range.start && offset < range.end)) {
          return match;
        }
        
        const before = result.substring(Math.max(0, offset - 10), offset);
        const after = result.substring(offset + match.length, Math.min(result.length, offset + match.length + 10));
        
        if (targetLanguage === 'ge' && /[\u10A0-\u10FF]/.test(match)) {
          return match; 
        }
        
        const translation = translations[targetLanguage];
        translatedRanges.push({ start: offset, end: offset + match.length });
        
        if (match[0] === match[0].toUpperCase()) {
          return translation.charAt(0).toUpperCase() + translation.slice(1);
        }
        return translation;
      });
    }
  }
  
  return result;
}